module.exports = __webpack_public_path__ + "img/home_bg.18c5dc44.png";